export const initialClientsEventBooking = {
  clientAttributes: {
    firstName: '',
    lastName: '',
    email: '',
    address: { zipCode: '' },
    bestPhoneNumber: { phoneNo: '' },
  },
};
